// Generated by Melange

import * as ReactRouter from "@tanstack/react-router";
import * as Routes__Root from "./root.jsx";
import * as Shared__Layout from "../shared/layout.jsx";
import * as Shared__RouterUtils from "../shared/routerUtils.jsx";
import * as Stdlib__Fun from "melange/fun.jsx";

const route = ReactRouter.createRoute({
  beforeLoad: Shared__RouterUtils.requireSubsonicCredentials,
  component: Shared__Layout.make,
  getParentRoute: (function (param) {
    return Stdlib__Fun.$$const(Routes__Root.route, param);
  }),
  id: "/_layout",
  pendingComponent: Shared__Layout.make
});

export {
  route,
}
/* route Not a pure module */
